import MainLayout from "@/components/layout/admin/MainLayout.vue";
import TeacherLeaveForm from "@/components/common/teacher_leave/TeacherLeaveForm.vue";
import EmployeeSelect from "@/components/common/EmployeeSelect.vue";
import Loading from "vue-loading-overlay";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import ValidationService from '@/services/ValidationService';

export default {
  name: "leaveCreate",
  components: {
    MainLayout,
    EmployeeSelect,
    Loading,
    TeacherLeaveForm,
  },
  mixins: [ValidationService],

  data() {
    return {
      CONFIG,
      leaveData: {
        employee_id: null,
        period: [],
        from_date: null,
        to_date: null,
        remark: null,
        status: null,
        leave_images: [],
        selected_leave_type: null
      },
      leaveTypeOptions: [],
      submitted: false,
      disabled: false,
      isLoading: false,
      images: [],
      formValidations: null,
      periodOptions: {},
      tbdId: null,
    };
  },

  methods: {
    setValidations(validations) {
      this.formValidations = validations;
    },

    async getLeaveLists() {
      if (!this.leaveData.employee_id) return;
      const params = {
        employee_id: this.leaveData.employee_id,
      };
      try {
        const res = await axios.get('leaveType/type-list', {params});
        this.leaveTypeOptions = res.data
          .filter(item => item.type !== 'TBD')
          .map(item => {
            return {
              id: item.id,
              text: item.type
            }
        });
        const tbdOption = res.data.find(item => item.type === 'TBD');
        this.tbdId = tbdOption ? tbdOption.id : null;
      } catch(error) {
        if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
      }
    },

    handlePeriodOptions(periodOptions) {
      this.periodOptions = periodOptions;
    },

    formatPeriodForRequest(periods) {
      const result = { request_date: {} };
      const groupedByDate = {};
      const validDates = Object.keys(this.periodOptions)

      periods.forEach(p => {
        if (!validDates.includes(p.date)) return
        if (!groupedByDate[p.date]) groupedByDate[p.date] = [];
        groupedByDate[p.date].push(p);
      });

      Object.entries(groupedByDate).forEach(([date, datePeriods]) => {
        const groupedByShift = {};

        datePeriods.forEach(p => {
          const shiftKey = `shift${p.shift}`;
          
          if (!groupedByShift[shiftKey]) {
            groupedByShift[shiftKey] = [{ 
              from_time: p.from, 
              to_time: p.to 
            }];
          } else {
            let currentRange = groupedByShift[shiftKey][0];
            if (p.from < currentRange.from_time) {
              currentRange.from_time = p.from;
            }
            if (p.to > currentRange.to_time) {
              currentRange.to_time = p.to;
            }
          }
        });
        result.request_date[date] = groupedByShift;
      });

      return result;
    },

    create() {
      if (this.disabled) return;
      this.isLoading = true;
      this.submitted = true;
      this.disabled = true;

      this.formValidations.$touch(); 
      if (this.formValidations.$invalid || (this.isHrOperator && !this.leaveData.employee_id)) {
        this.isLoading = false;
        this.disabled = false;
        return;
      }
      this.leaveData.leave_images = this.images;
      const periodPayload = this.formatPeriodForRequest(this.leaveData.period)
      const payload = {
        ...this.leaveData,
        period: periodPayload
      }
      axios.post(`${this.leaveApiBase}/create`, payload)
        .then(res => {
          if(res.data.success == true) {
            this.$notification.success("Leave Form Create Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: 'teacherLeaveList'
            })
          }
        }).catch((error) => {
          this.disabled = false;
          this.isLoading = false;
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
            if (error.response.status == 422) {
              this.printValidationError(error.response);
              this.$notification.error(error.response.data.message, {
                timer: 3,
                position: "bottomCenter",
              });
            }
          }
        });
    },
  },

  computed: {
    isHrOperator() {
      const role = Number(this.$store.state.user?.role);
      return role === CONFIG.ROLE.ID.HR_OPERATOR || role === CONFIG.ROLE.ID.SUPER_ADMIN;
    },
    leaveApiBase() {
      return this.isHrOperator ? 'hr/employee-leave' : 'employee-leave';
    },
  },

  watch: {
    'leaveData.employee_id': {
      handler(newVal) {
        if (!newVal) {
          this.leaveTypeOptions = [];
          return;
        }
        this.getLeaveLists();
      },
      immediate: true
    }
  },

  created() {
    if (!this.isHrOperator) {
      this.leaveData.status = CONFIG.SHIFT_LEAVE_STATUS.REQUEST;
    }
  },

  mounted() {
    this.isLoading = false;
  }
};
